import axios from 'axios';
import { logout } from '../context/AuthContext';

const firehouseApiUrl = (window.location.host == "v3-staging.firehouse247.com")?process.env.REACT_APP_FIREHOUSE_API_URL_STAGING : process.env.REACT_APP_FIREHOUSE_API_URL;

const getUrlPrefix = () => {
  const department = localStorage.getItem('department');

  return `https://${department}.${firehouseApiUrl}`;
};

let reqArray = [];
const cancelTokenSource = name => {
  let req = axios.CancelToken.source();
  reqArray[name] = req;
  return req;
};

const ApiService = {
  get(url, params = {}, cancelName = '', responseType = '') {
    if (cancelName !== '') {
      this.cancel(cancelName);
    }
    let cancelToken = cancelTokenSource(cancelName);
    return new Promise((resolve, reject) => {
      axios
        .get(getUrlPrefix() + url, {
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
          params: params,
          cancelToken: cancelToken.token,
          signal: cancelToken.signal,
          responseType,
        })
        .then(response => resolve(response))
        .catch(error => {
          if (error.response && error.response.status === 401) {
            logout();
          }
          if (error.name !== 'CanceledError') {
            reject(error);
          }
        });
    });
  },

  post(url, body = {}, params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .post(getUrlPrefix() + url, body, {
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
          params: params,
        })
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response));
    });
  },

  put(url, body = {}, params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .put(getUrlPrefix() + url, body, {
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
          params: params,
        })
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response));
    });
  },

  patch(url, body = {}, params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .patch(getUrlPrefix() + url, body, {
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
          params: params,
        })
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response));
    });
  },

  delete(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .delete(getUrlPrefix() + url, {
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
          params: params,
        })
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response));
    });
  },

  cancel(name) {
    if (reqArray[name]) {
      reqArray[name].cancel('API request canceled');
    }
  },
};

export default ApiService;
